import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// import { IResponseData } from '@/types/IResponseData';
class DeliveryChargeAreaApi extends Requestor {
    getDeliveryChargeAreaList(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/areas`,
            params,
        });
    }
    getDeliveryChargeArea(hubId = '', areaId = 0, params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/areas/${areaId}`,
            params,
        });
    }
    postDeliveryChargeArea(hubId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/areas`,
            data,
        });
    }
    putDeliveryChargeArea(hubId = '', areaId = 0, data = {}) {
        return this.put({
            url: `/api/v1/hubs/${hubId}/areas/${areaId}`,
            data,
        });
    }
    deleteDeliveryChargeArea(hubId = '', areaId = 0) {
        return this.delete({
            url: `/api/v1/hubs/${hubId}/areas/${areaId}`,
        });
    }
}
export default new DeliveryChargeAreaApi(clientInstance);
